
import { defineComponent, ref, onMounted } from "vue";
import { Order } from "@/utils/api/order";
import { ElMessage } from 'element-plus';

export default defineComponent({
  props: {
    money: Number,
		order: Object
  },
  setup(props, context) {
    //计时器
    const time = ref("");
    var maxtime = ref(15 * 60);
    const timer = () => {
      let minutes = Math.floor(maxtime.value / 60);
      let seconds = Math.floor(maxtime.value % 60);
      time.value = minutes + "分" + seconds + "秒";
      if (maxtime.value > 0) maxtime.value -= 1;
    };
    onMounted(() => {
      setInterval(timer, 1000);
    });
    //支付方式
    const aliPay = ref(true);
    const wechatPay = ref(false);
    const wechat = () => {
      wechatPay.value = true;
      aliPay.value = false;
    };
    const ali = () => {
      wechatPay.value = false;
      aliPay.value = true;
    };
    //提交表单
    const submit = () => {
      if (maxtime.value == 0) {
        openError('订单已经超时，无法支付！');
      } else {
				Order.sendOrder(props.order as any)
				.then((res) => {
					console.log(res.data);
          if(res.data.msg === '订单重复！') {
            openError('订单重复！')
          } else if(res.data.success === 1) {
            context.emit('next2');
          } else if(res.data.success === -1) {
            openError('您的乘客已购买该航班！');
          } else if(res.data.success === -2) {
            openError('余票不足！');
          }else if(res.data.success === -3) {
            openError('信用不够！');
          } else {
            openError('出错了，请联系管理员！');
          }
					
				})
				.catch((error) => {
					console.log(error)
				});
			}	
		};
    const openError = (msg: string) => {
      ElMessage({
            showClose: true,
            message: msg,
            type: 'error',
            offset: 200,
          });
    }
    return {
      time,
      maxtime,
      aliPay,
      wechatPay,
      wechat,
      ali,
      submit,
    };
	}	
});
